let block_lenght=$('.custom_product_images_bundle').length
for (let oindex = 0; oindex < block_lenght; oindex++) {
  $(`.custom_product_images_bundle .custom_product_images_main_in${oindex}`).flickity({
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  freeScroll: false
  });
  let check=$(`.custom_product_images_bundle .custom_product_images_thumb_in${oindex}`).data('length')>4 ? true : false;
$(`.custom_product_images_bundle .custom_product_images_thumb_in${oindex}`).flickity({
  asNavFor: `.custom_product_images_bundle .custom_product_images_main_in${oindex}`,
   contain: true,
  cellAlign: 'center',
  pageDots: false,
  draggable: true,
  wrapAround: false,
  prevNextButtons: false,
  freeScroll: false
});
$(`.custom_product_images_thumb_in${oindex}`).on( 'change.flickity', function( event, index ) {
$(`.custom_product_images_main_in${oindex}`).flickity( 'select', index );
});
}

$('.gallery_popup_main').flickity({
  contain: true,
  pageDots: false,
  draggable: false,
  fade: true
});

$(document).on('click','.custom_product_images_bundle.showing .custom_product_images_main .product__photo-zoom',function() {
  let index = $(this).attr('data-index');
  $('body').addClass('stopscroll');
  $('.gallery_popup_bundle.showing .gallery_popup_main').flickity( 'select', index );
  $('.custom_gallery_popup').addClass('showing');
      setTimeout(function() {
         $(window).trigger('resize');
      },200)
});
$('.custom_gallery_popup .pswp__button--close').click(function() {
  $(this).parent().removeClass('showing');
  $('body').removeClass('stopscroll');
})


$('.gallery_popup_image-wrap').zoom({ on:'click',magnify:2,callback: function(){
      $(this).parent().toggleClass('active')
    } });	
$('.product-single__form .variant-input-wrap input').click(function() {
    hideextraimages($(this));
});
hideextraimages($('.product-single__form .variant-input-wrap input:checked'));

function hideextraimages(thus){
      setTimeout(function(){
    let cvarid = window.location.search.split('=')[1];
        if(cvarid){
        }
        else{
          cvarid=selectedcurrentvar;
        }
    $('.product__quantity--button').attr('data-avalvariant').includes(cvarid)? $('.product__quantity--button').show():$('.product__quantity--button').hide();
  }, 200);
 
    let a=thus.attr('data-alt');

thus.parents('.page-content--product').find('.custom_product_gallery_wrapper').find(`.custom_product_images_bundle[data-bundle='${a}']`).addClass('showing').siblings('.custom_product_images_bundle').removeClass('showing');
thus.parents('.page-content--product').find('.gallery_popup_bundles').find(`.gallery_popup_bundle[data-bundle='${a}']`).addClass('showing').siblings('.gallery_popup_bundle').removeClass('showing');
  
}


$(document).ready(function() {
    function initFlickity() {
        $('.page-width.logo__animation_wrapepr .logo-bar').flickity({
            cellAlign: 'center',
            wrapAround: true,
          prevNextButtons: false
        });
    }
    function destroyFlickity() {
        var flkty = $('.page-width.logo__animation_wrapepr .logo-bar').data('flickity');
        if (flkty) {
            flkty.destroy();
        }
    }
    if ($(window).width() < 750) {
        initFlickity();
    }
    $(window).resize(function() {
        if ($(window).width() < 750) {
            initFlickity();
        } else {
            destroyFlickity();
        }
    });
});

$('.product-single__form .variant-input-wrap input').click(function() {
    hidesizeimages($(this));
});
hidesizeimages($('.product-single__form .variant-input-wrap input:checked'));
function hidesizeimages(thus){
      setTimeout(function(){
    let cvarid = window.location.search.split('=')[1];
             if(cvarid){
        }
        else{
          cvarid=selectedcurrentvar;
        }
          $('.our-selected-images div').each(function () {
              if($(this).attr('data-invar').includes(cvarid)){
              $(this).show().siblings().hide()
              } 
          })
  }, 200);
}

$(document).ready(function() {
    $('.rapi-bundles__bar').on('click', function() {
        $('.rapi-bundles__bar').removeClass('active-bundle');
        $(this).addClass('active-bundle');
    });

$(document).ready(function () {
  $('input[type="radio"][name="rapi-bundles-deal"]').change(function () {
    // Get the text content of the price
    var selectedPrice = $(this).siblings('label').find('.rapi-bundles__bar-price').text();

    // Remove currency symbols ($, €, etc.) and keep only the number
    var cleanedPrice = selectedPrice.replace(/[^0-9.,]/g, '');

    // Display the cleaned price
    $('.heee').text(cleanedPrice);
  });
});

});




  